<script>
</script>

<div class="container">
  <div class="image-container shimmer" />
  <div class="content">
    <div class="title shimmer" />
    <p class="summary shimmer" />
  </div>
</div>

<style>
  .container {
    padding: 12px 0;
    display: flex;
  }

  .image-container {
    border-radius: 16px;
    min-width: 78px;
    height: 78px;
  }

  .content {
    width: 100%;
    margin-left: 16px;
  }

  .title {
    height: 35px;
    margin: 0;
    margin: 0 0 8px 0;
  }

  .summary {
    height: 35px;
    margin: 0;
  }
</style>
